<template>
  <div class="main-feed mt-5">
    <div>
      <v-row class="ma-0">
        <h2>Members Only Content</h2>
      </v-row>
      <div v-if="content" v-html="content"></div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import userService from "@/services/portal/userService";

export default Vue.extend({
  name: "MembersOnlyEdit",
  data: function () {
    return {
      errors: [] as string[],
      content: null
    };
  },
  methods: {
  },
  created: function () {
    userService
      .getMembersOnlyInfo()
      .then((res) => {
        this.content = res.data;
      })
      .catch(this.$handleError);
  },
});
</script>
